



































import { isMobile } from "@/lib/utility/isMobile";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class MDetailViewGrid extends Vue {
  @Prop({ default: true })
  bottomSheet!: boolean;

  @Prop({ default: false })
  center!: boolean;

  @Prop({ default: "450px" })
  bottomSheetHeight!: string;

  @Prop({ default: 4, type: Number, required: false })
  detailColMd!: number;

  get detailColXl() {
    return this.detailColMd - 1;
  }

  isBottomSheetOpen = false;

  swipeDirection = "";
  swipe(swipe: string) {
    this.swipeDirection = swipe;
  }

  get isMobile() {
    return isMobile() || this.$vuetify.breakpoint.smAndDown;
  }

  get showDetails() {
    if (!this.bottomSheet) {
      return true;
    }

    return !this.isMobile;
  }

  get closeOnSwipe() {
    return {
      down: () => this.closeBottomSheet()
    };
  }

  closeBottomSheet() {
    this.isBottomSheetOpen = false;
  }
}
